(() => {
if (customElements.get('seed-media-carousel')) return;

class SeedMediaCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
    this.index = 0;
    this.isWrapping = false;
    if (!this.track || this.slides.length < 2) return;
    this.track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => this.updateIndex());
    }, { passive: true });
    const delay = Number(this.dataset.autoplay) || 4000;
    this.autoplayTimer = window.setInterval(() => {
      if (document.hidden) return;
      if (this.hasAttribute('data-mobile-only') && !window.matchMedia('(max-width: 749px)').matches) return;
      this.advance();
    }, delay);
  }

  advance() {
    if (this.isWrapping) return;
    if (this.index < this.slides.length - 1) {
      this.goTo(this.index + 1);
      return;
    }

    this.ensureClone();
    this.isWrapping = true;
    this.clone.hidden = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.track.scrollTo({ left: this.clone.offsetLeft, behavior: 'smooth' });
      });
    });

    let completed = false;
    const resetToFirst = () => {
      if (completed) return;
      completed = true;
      window.clearTimeout(this.wrapTimer);
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = this.slides[0].offsetLeft;
      this.index = 0;
      this.clone.hidden = true;
      this.isWrapping = false;
      requestAnimationFrame(() => this.track.style.removeProperty('scroll-behavior'));
    };
    this.wrapTimer = window.setTimeout(resetToFirst, 850);
  }

  ensureClone() {
    if (this.clone) return;
    this.clone = this.slides[0].cloneNode(true);
    this.clone.removeAttribute('data-carousel-slide');
    this.clone.setAttribute('data-carousel-clone', '');
    this.clone.setAttribute('aria-hidden', 'true');
    this.clone.hidden = true;
    this.clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
    this.track.append(this.clone);
  }

  goTo(index) {
    this.index = Math.max(0, Math.min(index, this.slides.length - 1));
    this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: 'smooth' });
  }

  updateIndex() {
    const trackLeft = this.track.getBoundingClientRect().left;
    let nearestIndex = 0;
    let nearestDistance = Infinity;
    this.slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });
    this.index = nearestIndex;
  }

  disconnectedCallback() {
    window.clearInterval(this.autoplayTimer);
    window.clearTimeout(this.wrapTimer);
    cancelAnimationFrame(this.rafId);
  }
}

customElements.define('seed-media-carousel', SeedMediaCarousel);
})();
